<template>
  <div>
    <div class="faq-content-all">
      <h1>FAQ's</h1>
      <div v-for="({q, a}, i) in qs" :key="i" class="single-faq-list">
        <h4>{{q}}</h4>
        <p>{{a}}</p>
      </div>
    </div>
    <div class="disposals">
      <h1>Disposal</h1>
      <div v-for="({h, v}, i) in disposals" :key="i" class="sigle-dsp">
        <h2>{{h}}</h2>
        <p>{{v}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      qs: [
        {
          q: 'How long does each filter refill last?',
          a:
            'Each filter refill is designed to last 200 litres (44 gallons) or 45 days.'
        },
        {
          q: 'Is the product dishwasher safe?',
          a:
            'The glass body of the product is dishwasher safe, however none of the other parts can be put in the dishwasher.'
        },
        {
          q: 'What minerals are added with the Alkaline Pack?',
          a:
            'The Alkaline Pack will add sodium, calcium and magnesium to the water.'
        },
        {
          q: 'Does it remove fluoride?',
          a: 'The filter is not built to remove fluoride.'
        }
      ],
      disposals: [
        { h: 'Refill Bags', v: 'Food waste bin' },
        { h: 'Refill Box', v: 'Widely recycled' },
        { h: 'Carbon Felt', v: 'General waste' },
        { h: 'Filter Contents', v: 'General waste' }
      ]
    }
  }
}
</script>

<style>
</style>